import { onMounted, onUnmounted } from 'vue'

export function useNavigation({
                                  flattenedNodes,
                                  highlightedIndex,
                                  selectNode,
                                  openContextMenu,
                                  closeContextMenu,
                                  openContextMenuByUser,
                                  toggleDeletedDropdown,
                                  selectedUserListType,
                                  deletedElement,
                                  selectedUserIndex,
                                  showDeleted,
                                  filteredElements
                              }) {
    function onGlobalKeyUp(e) {
        if (e.key === 'Meta') {
            // ...
        }
    }
    onMounted(() => {
        window.addEventListener('keyup', onGlobalKeyUp)
    })
    onUnmounted(() => {
        window.removeEventListener('keyup', onGlobalKeyUp)
    })

    let lastRightArrowTime = 0

    // function expandAll(node) {
    //     node.expanded = true
    //     if (node.children?.length) {
    //         node.children.forEach(child => expandAll(child))
    //     }
    // }

    function handleTreeKeydown(e) {
        console.log(e, 'E')
        e.stopPropagation()
        if (!flattenedNodes.value.length) return
        if (highlightedIndex.value < 0) {
            highlightedIndex.value = 0
        }
        const idx = highlightedIndex.value
        const node = flattenedNodes.value[idx]

        switch (e.key) {
            case 'ArrowDown':
                if (idx < flattenedNodes.value.length - 1) {
                    highlightedIndex.value++
                    selectNode(flattenedNodes.value[highlightedIndex.value].node)
                    // e.preventDefault()
                }
                break
            case 'ArrowUp':
                if (idx > 0) {
                    highlightedIndex.value--
                    selectNode(flattenedNodes.value[highlightedIndex.value].node)
                    // e.preventDefault()
                }
                break
            case 'ArrowLeft':
                const n = flattenedNodes.value[highlightedIndex.value].node
                if (n.expanded) {
                    n.expanded = false
                } else {
                    const parentIdx = flattenedNodes.value
                        .findIndex(f => f.node.grp_id === n.parent_id)
                    if (parentIdx !== -1) {
                        highlightedIndex.value = parentIdx
                        selectNode(flattenedNodes.value[parentIdx].node)              // ★
                    }
                }
                break
            case 'ArrowRight': {
                const n = flattenedNodes.value[highlightedIndex.value].node
                if (n.children?.length && !n.expanded) n.expanded = true
                break
            }
            case ' ':
                openContextMenu(
                    e,
                    node.node_type === 'root' ? 'root' : 'group',
                    node,
                    'left'
                )
                e.preventDefault()
                break
            case 'Escape':
                closeContextMenu()
                e.preventDefault()
                break
        }
    }

    function handleDeletedKeydown(e) {
        e.stopPropagation()

        if (selectedUserListType.value !== 'deleted') {
            selectedUserListType.value = 'deleted'
            if (selectedUserIndex.value < 0) {
                selectedUserIndex.value = 0
            }
        }

        const users = deletedElement.value
        if (!users.length) {
            if (e.key === 'Enter' || e.key === ' ') {
                toggleDeletedDropdown()
                e.preventDefault()
            }
            return
        }
        if (selectedUserIndex.value < 0) selectedUserIndex.value = 0
        if (selectedUserIndex.value >= users.length) {
            selectedUserIndex.value = users.length - 1
        }

        switch (e.key) {
            case 'Enter':
            case ' ':
                if (selectedUserIndex.value >= 0) {
                    const user = users[selectedUserIndex.value]
                    openContextMenuByUser(user, selectedUserIndex.value, e, 'left')
                }
                e.preventDefault()
                break
            case 'Escape':
                closeContextMenu()
                e.preventDefault()
                break
        }
    }

    function handleRightKeydown(e) {
        e.stopPropagation()
        if (selectedUserIndex.value == null) {
            selectedUserIndex.value = -1
        }
        if (selectedUserIndex.value < -1) {
            selectedUserIndex.value = -1
        }
        if (selectedUserListType.value !== 'active') {
            selectedUserListType.value = 'active'
        }
        const users = filteredElements.value
        const maxIndex = users.length - 1

        switch (e.key) {
            case 'ArrowDown': {
                if (selectedUserIndex.value < 0) {
                    selectedUserIndex.value = 0
                } else if (selectedUserIndex.value < maxIndex) {
                    selectedUserIndex.value++
                }
                e.preventDefault()
                break
            }
            case 'ArrowUp': {
                if (selectedUserIndex.value > 0) {
                    selectedUserIndex.value--
                } else if (selectedUserIndex.value === 0) {
                    selectedUserIndex.value = -1
                }
                e.preventDefault()
                break
            }
            case 'Enter':
/*
            case ' ':
                if (selectedUserIndex.value === -1) {
                    showDeleted.value = !showDeleted.value
                } else {
                    const idx = selectedUserIndex.value
                    if (idx >= 0 && idx < users.length) {
                        const user = users[idx]
                        openContextMenuByUser(user, idx, e, 'right')
                    }
                }
                e.preventDefault()
                break
*/
            case 'Escape':
                closeContextMenu()
                e.preventDefault()
                break
        }
    }

    return {
        handleTreeKeydown,
        handleDeletedKeydown,
        handleRightKeydown
    }
}
